<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="container">
      <div class="page-width">
        <div class="header_container">
          <h3>{{ $t('orderHistory') }}</h3>
          <div>
            <p v-show="this.$store.state.warehouseOrder.orderTimeFrame.length===0">{{ $t('noPlacedOrder') }}</p>
            <div class="filter-options-container">
              <el-select class="filter-item" v-model="option" v-bind:placeholder="$t('last1Month')" value="" @change="updateFilter">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="main-content">
          <!-- login  -->
          <div v-show="loggedIn===true" class="customers_acc">
            <div class="grid">
              <div class="grid__item medium-up--two-thirds">
                <table v-show="this.$store.state.warehouseOrder.orderTimeFrame.length>0" class="responsive-table">
                  <thead>
                    <tr>
                      <th>{{ $t('orderNo') }}</th>
                      <th>{{ $t('order') }}</th>
                      <th>{{ $t('paymentStatus') }}</th>
                      <th>{{ $t('shippingStatus') }}</th>
                      <th>{{ $t('total') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(order, index) in this.$store.state.warehouseOrder.orderTimeFrame" data-index="index" :key="index">
                      <!-- <td data-label="Order"> -->
                      <td v-bind:data-label="$t('order')">
                        <p class="btn" @click="navTo(order.SalesOrder_id)">
                          #{{order.SONum}}
                        </p>
                      </td>
                      <td v-bind:data-label="$t('date')">{{order.OrderDate}}</td>
                      <td v-bind:data-label="$t('paymentStatus')">{{order.PaymentStatus}}</td>
                      <td v-bind:data-label="$t('fulfillmentStatus')">{{order.ShippingStatus}}</td>
                      <td v-bind:data-label="$t('total')">${{order.FinalPrice}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "../components/breadcrumb";

export default {
  name: "warehouseOrderHistory",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: this.$t("orderHistory"),
      orderTimeFrame:[],
      loaded: false,
      option: '',
      options: [
        {
          value: '1',
          label: 'last1Month'
        }, {
          value: '2',
          label: 'last2Month'
        }, {
          value: '3',
          label: 'last3Month'
        },{
          value: '4',
          label: 'all'
        },
      ],
      activeTabName: null,
      list:[],
    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapActions('warehouseOrder', ['fetchOrderByTimeFrame','fetchOrderDetails']),
    navTo(id) {
      this.$router.push({name: 'warehouseOrderHistoryDetail', params: {order_id: id}});
    },
    updateFilter(value) {
      if(value === '1') {
        this.$store.dispatch('warehouseOrder/fetchOrderByTimeFrame', 1);
      }
      if(value === '2') {
        this.$store.dispatch('warehouseOrder/fetchOrderByTimeFrame', 2);
      }
      if(value === '3') {
        this.$store.dispatch('warehouseOrder/fetchOrderByTimeFrame', 3);
      }
      if(value=== '4'){
        this.$store.dispatch('warehouseOrder/fetchOrderByTimeFrame', 99);
      }     
    },
  },
  mounted() {
    //const month = 3;
    this.$store.dispatch('warehouseOrder/fetchOrderByTimeFrame', 1);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {
    '$store.state.warehouseOrder.orderTimeFrame': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../assets/css/warehouseOrderHistory.less";
</style>



// WEBPACK FOOTER //
// src/view/warehouseOrderHistory.vue